import styled from 'styled-components';
import ServerStylesConditionalWrapper from './ServerStylesConditionalWrapper';

const StyledDiv = styled.div`
  height: 100%;
`;

const WidgetIdWrapper = ({
  widgetID,
  children,
  className,
  withServerStylesConditionalWrapper = true
}) =>
  withServerStylesConditionalWrapper ? (
    <ServerStylesConditionalWrapper className={className}>
      <StyledDiv id={widgetID}>{children}</StyledDiv>
    </ServerStylesConditionalWrapper>
  ) : (
    <StyledDiv id={widgetID}>{children}</StyledDiv>
  );

export default WidgetIdWrapper;

/**
 * Higher-order component to wrap any non-widget components.
 */
export const withWidgetIdWrapper =
  (Component) =>
  ({ widgetID, className, withServerStylesConditionalWrapper = true, ...passThroughProps }) =>
    (
      <WidgetIdWrapper
        className={className}
        widgetID={widgetID}
        withServerStylesConditionalWrapper={withServerStylesConditionalWrapper}
      >
        <Component {...passThroughProps} />
      </WidgetIdWrapper>
    );
